/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 * 
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 * 
 * $Id: userfeedback.js
 */

$.namespace("SCS.userfeedback");

var pageCookie = "pageCookie";
var yesFirstQuestionValue = "yesFirstQuestion";
var noFirstQuestionValue = "noFirstQuestion";
var yesSecondQuestionValue = "yesSecondQuestion";
var noSecondQuestionValue = "noSecondQuestion";

SCS.userfeedback.init = function(resourceId) {
	$(document).ready(function() {
		var cookieValue = $.cookie(pageCookie);
		if (cookieValue == null) {
			$("#scs-help-userfeedback-first-question-" + resourceId).show();
			$("#scs-help-userfeedback-second-question-" + resourceId).hide();
			$("#message-" + resourceId).hide();
			$("#chat-" + resourceId).hide();
		} else if (cookieValue == yesFirstQuestionValue) {
			$("#scs-help-userfeedback-first-question-" + resourceId).hide();
			$("#scs-help-userfeedback-second-question-" + resourceId).show();
			$("#message-" + resourceId).hide();
			$("#chat-" + resourceId).hide();
		} else {
			$("#scs-help-userfeedback-first-question-" + resourceId).hide();
			$("#scs-help-userfeedback-second-question-" + resourceId).hide();
			$("#message-" + resourceId).show();
		}
	});
};

function yesFirstQuestion(firstQuestion, resourceId) {
	var siteCatalyst = window.s || window.s_one;
	if (siteCatalyst && siteCatalyst.tl) {
		siteCatalyst.eVar52 = siteCatalyst.pageName;
		siteCatalyst.linkTrackVars = 'eVar52,events';
		siteCatalyst.linkTrackEvents = 'event56';
		siteCatalyst.events = 'event56';
		siteCatalyst.tl(this, 'o', firstQuestion);
	}
	$("#scs-help-userfeedback-first-question-" + resourceId).hide();
	$("#scs-help-userfeedback-second-question-" + resourceId).show();
	$.cookie(pageCookie, yesFirstQuestionValue, {
		expires : 2,
		path : window.location.pathname
	});
}

function noFirstQuestion(firstQuestion, resourceId) {
	var siteCatalyst = window.s || window.s_one;
	if (siteCatalyst && siteCatalyst.tl) {
		siteCatalyst.eVar52 = siteCatalyst.pageName;
		siteCatalyst.linkTrackVars = 'eVar52,events';
		siteCatalyst.linkTrackEvents = 'event57';
		siteCatalyst.events = 'event57';
		siteCatalyst.tl(this, 'o', firstQuestion);
	}

	$("#scs-help-userfeedback-first-question-" + resourceId).hide();
	$("#message-" + resourceId).hide();
	$("#chat-" + resourceId).show();
	$.cookie(pageCookie, noFirstQuestionValue, {
		expires : 2,
		path : window.location.pathname
	});
}

function yesSecondQuestion(secondQuestion, resourceId) {
	var siteCatalyst = window.s || window.s_one;
	if (siteCatalyst && siteCatalyst.tl) {
		siteCatalyst.eVar52 = siteCatalyst.pageName;
		siteCatalyst.linkTrackVars = 'eVar52,events';
		siteCatalyst.linkTrackEvents = 'event58';
		siteCatalyst.events = 'event58';
		siteCatalyst.tl(this, 'o', secondQuestion);
	}

	$("#scs-help-userfeedback-second-question-" + resourceId).hide();
	$("#message-" + resourceId).show();
	$.cookie(pageCookie, yesSecondQuestionValue, {
		expires : 2,
		path : window.location.pathname
	});
}

function noSecondQuestion(secondQuestion, resourceId) {
	var siteCatalyst = window.s || window.s_one;
	if (siteCatalyst && siteCatalyst.tl) {
		siteCatalyst.eVar52 = siteCatalyst.pageName;
		siteCatalyst.linkTrackVars = 'eVar52,events';
		siteCatalyst.linkTrackEvents = 'event59';
		siteCatalyst.events = 'event59';
		siteCatalyst.tl(this, 'o', secondQuestion);
	}

	$("#scs-help-userfeedback-second-question-" + resourceId).hide();
	$("#message-" + resourceId).show();
	$("#chat-" + resourceId).hide();
	$.cookie(pageCookie, noSecondQuestionValue, {
		expires : 2,
		path : window.location.pathname
	});
}


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/userfeedback.js
// module id = 82
// module chunks = 0